import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-survey-landing',
  standalone: true,
  imports: [MatCardModule],
  templateUrl: './survey-landing-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './survey-landing-page.component.scss',
})
export class SurveyLandingComponent {}
